import { render, staticRenderFns } from "./quotationMateral-add-or-update.vue?vue&type=template&id=5837e3a8"
import script from "./quotationMateral-add-or-update.vue?vue&type=script&lang=js"
export * from "./quotationMateral-add-or-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports